import * as React from 'react';
import { LinkProps } from 'next/link';
import { NoSsr } from '@mui/material';
import { useRouter } from 'next/router';
import Link from '../Link/Link';
import {
  useMediaQueryBreakPoint,
  IS_PHONE_OR_TABLET,
} from '../../../src/hooks';

type Props = {
  children: React.ReactNode;
} & LinkProps;

function LinkWrapper({
  href,
  children,
  ...props
}: { href: string } & Omit<Props, 'href'>) {
  const router = useRouter();
  const isPhoneOrTablet = useMediaQueryBreakPoint(IS_PHONE_OR_TABLET);

  if (React.isValidElement(children)) {
    if (isPhoneOrTablet) {
      return React.cloneElement<{ onClick: React.MouseEventHandler }>(
        children as React.ReactElement<{
          onClick: React.MouseEventHandler;
        }>,
        {
          onClick: e => {
            e.preventDefault();
            e.stopPropagation();
            router.push(
              `/download-app?link=${encodeURIComponent(href)}`,
              props.as,
              {
                scroll: props.scroll,
                shallow: props.shallow,
                locale: props.locale,
              },
            );
          },
        },
      );
    }

    return React.cloneElement(children, props);
  }

  return children;
}

const DeepLink: React.FC<Props> = ({ children, href, ...props }) => {
  return (
    <NoSsr>
      <Link {...props} href={href} passHref>
        {/* ts-ignore is needed here, because href is passed by the <Link> component to its children, so TS doesn't know */}
        {/* @ts-ignore */}
        <LinkWrapper {...props}>{children}</LinkWrapper>
      </Link>
    </NoSsr>
  );
};

export default DeepLink;
